// extracted by mini-css-extract-plugin
module.exports = {"productWidgetApp":"_2Ibi-","horizontal":"_3AqU7","emptyState":"_2_3qm"};